import React from 'react';
import { Link } from 'react-router-dom';

let unit = 1024;
export const DeviceInfoTab2Table = [
  {
    title: '进程名称',
    dataIndex: 'name'
  },
  {
    title: 'CPU使用率(%)',
    dataIndex: 'cpu_usage'
  },
  {
    title: '内存使用率(%)',
    dataIndex: 'memory_usage'
  },
  {
    title: '存储占用率(%)',
    dataIndex: 'storage_usage'
  },
  {
    title: '宽带/WiFi网络流量(M)',
    dataIndex: 'network_traffic'
  },
  {
    title: '移动流量(M)',
    dataIndex: 'data_traffic'
  }
];
export const OTATableData = [
  {
    title: '设备编号',
    dataIndex: 'device_id'
  },
  {
    title: '当前版本',
    dataIndex: 'ota_current'
  },
  {
    title: '目标版本',
    dataIndex: 'ota_target'
  },
  {
    title: '更新至目标版本时间',
    dataIndex: 'update_time'
  }
];
export const TrafficModalColumns = [
  {
    title: '设备编号',
    dataIndex: 'device_id',
    key: 'device_id',
    render: text => (
      <Link style={{ color: '#49aff7' }} to={`/device/info/${text}`}>
        {text}
      </Link>
    )
  },
  { title: '当月移动流量(M)', dataIndex: 'detail', key: 'detail' },
  { title: 'ICCID', dataIndex: 'iccid', key: 'iccid' },
  { title: '设备地址', dataIndex: 'address', key: 'address' }
];
export const StorageModalColumns = [
  {
    title: '设备编号',
    dataIndex: 'device_id',
    key: 'device_id',
    render: text => (
      <Link style={{ color: '#49aff7' }} to={`/device/info/${text}`}>
        {text}
      </Link>
    )
  },
  {
    title: '当月存储占用率(%)',
    dataIndex: 'detail',
    key: 'detail'
  },
  { title: 'ICCID', dataIndex: 'iccid', key: 'iccid' },
  { title: '设备地址', dataIndex: 'address', key: 'address' }
];
export const OnlineModalColumns = [
  {
    title: '设备编号',
    dataIndex: 'device_id',
    key: 'device_id',
    render: text => (
      <Link style={{ color: '#49aff7' }} to={`/device/info/${text}`}>
        {text}
      </Link>
    )
  },
  { title: '上线次数', dataIndex: 'detail', key: 'detail' },
  { title: 'ICCID', dataIndex: 'iccid', key: 'iccid' },
  { title: '设备地址', dataIndex: 'address', key: 'address' }
];
export const DeviceStatusBtnGroup = [
  { label: '次数>5次', bgColor: 'default', value: 5 },
  { label: '次数>10次', bgColor: 'default', value: 10 },
  { label: '次数>15次', bgColor: 'default', value: 15 },
  { label: '次数>20次', bgColor: 'default', value: 20 },
  { label: '次数>30次', bgColor: 'default', value: 30 }
];
export const TrafficBtnGroup = [
  { label: '流量<20M', bgColor: 'default', value: 20 * unit },
  { label: '流量>50M', bgColor: 'default', value: 50 * unit },
  { label: '流量>70M', bgColor: 'default', value: 70 * unit },
  { label: '流量>100M', bgColor: 'default', value: 100 * unit },
  { label: '流量>200M', bgColor: 'default', value: 200 * unit }
];
export const StorageBtnGroup = [
  { label: '存储>50%', bgColor: 'default', value: 50 },
  { label: '存储>60%', bgColor: 'default', value: 60 },
  { label: '存储>70%', bgColor: 'default', value: 70 },
  { label: '存储>80%', bgColor: 'default', value: 80 },
  { label: '存储>90%', bgColor: 'default', value: 90 }
];
export const AddGroupTable = [
  {
    title: '设备编号',
    dataIndex: 'device_id'
  },
  {
    title: '设备型号',
    dataIndex: 'model'
  },
  {
    title: '固件版本',
    dataIndex: 'firmware_version'
  },
  {
    title: '设备地址',
    dataIndex: 'address'
  }
];



// WEBPACK FOOTER //
// ./src/const/TableConst.js